import script from "./ContinueInAppContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContinueInAppContent.vue?vue&type=script&lang=ts&setup=true"

import "./ContinueInAppContent.vue?vue&type=style&index=0&id=2ee9d78a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee9d78a"]])

export default __exports__